// init foundation
$(document).foundation();